var render = function render() {
  var _vm$height, _vm$width
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "upload-metadata-box",
    },
    [
      _c(
        "div",
        [
          _vm.fileURL
            ? _c("ThumbnailCard", {
                attrs: {
                  height:
                    (_vm$height = _vm.height) !== null && _vm$height !== void 0
                      ? _vm$height
                      : 0,
                  "mime-type": _vm.file.type,
                  size: _vm.file.size,
                  url: _vm.fileURL,
                  width:
                    (_vm$width = _vm.width) !== null && _vm$width !== void 0
                      ? _vm$width
                      : 0,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("AttributesFieldset", {
            attrs: {
              metadata: _vm.metadata,
              "suggested-tags": _vm.suggestedTags,
            },
            on: {
              change: _vm.onChange,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }